import _ from 'lodash';

export const findVariantByOptionValues = (state) => {
  const {
    optionValueGroups,
    variants,
    option_types,
    numberOfUsers,
    selectedOptionIndex,
    licenseSpan,
  } = state;

  if (_.isEmpty(variants) || _.isEmpty(optionValueGroups)) {
    return null;
  }

  // Get all the option values for the selected option group and the num_of_users option value
  const selectedGroup = optionValueGroups[selectedOptionIndex];
  const numberOfUsersOptionType = option_types.find(ot => ot.name === 'num_of_users');
  const numberOfUsersOptionValue = numberOfUsersOptionType.option_values.find((ov) => ov.name.split('-')[0] === numberOfUsers);
  const licenseSpanOptionType = option_types.find(ot => ot.name === 'license_span');
  const licenseSpanOptionValue = licenseSpanOptionType.option_values.find(ov => ov.name === licenseSpan);

  const foundVariant = _.find(variants, (variant) => {
    if (_.isEmpty(variant.option_values)) return false;

    return _.every(variant.option_values, (optionValue) => {
      switch (optionValue.option_type_id) {
        case licenseSpanOptionType.id:
          return optionValue.id === licenseSpanOptionValue.id;
        case numberOfUsersOptionType.id:
          return numberOfUsersOptionValue && optionValue.id === numberOfUsersOptionValue.id;
        case selectedGroup.licenseTypeOptionTypeId:
          return optionValue.id === selectedGroup.licenseTypeId;
        case selectedGroup.activationMethodOptionTypeId:
          return optionValue.id === selectedGroup.activationMethodId;
        default:
          return false;
      }
    });
  });

  return foundVariant;
};